import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetSportHikes } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { sportExpeditionsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfSportExpeditionContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const studentExpeditions = useAppSelector(sportExpeditionsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().sportExpeditions });

  const hasData = studentExpeditions.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(studentExpeditions, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Походы и экспедиции" Icon={IconWidgetSportHikes}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfSportExpeditionContainer;
